import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import ContentEditable from 'react-contenteditable';
import React from 'react';
import PropTypes from 'prop-types';
import InputFile from '../../inputFile';
import AttachedFile from '../../files/attachedFile';
import GifPicker from '../gifPicker';
import AllowGifEmoji from '../../../components/modules/allowGifEmoji';
import './styles.css';

const AddNew = ({
  t,
  label,
  attach,
  errorMessage,
  showGif,
  showEmo,
  sendGif,
  openGifs,
  addEmoji,
  preSubmit,
  openEmoji,
  newComment,
  changeText,
  onKeyPress,
  upload_name,
  placeholder,
  cancelEdit,
  isSubmitting,
  isEditing,
  mulTempFiles,
  checkKeyPress,
}) => (
  <React.Fragment>
    <div className="addcmnt">
      <h6>{label}</h6>
      <form
        onSubmit={preSubmit}
      >
        <ContentEditable
          html={newComment}
          disabled={false}
          onChange={changeText}
          onKeyPress={checkKeyPress && onKeyPress}
          className="form-control msgtextarea fontmulisemi input-ext msg-input"
          data-placeholder={placeholder}
        />
        <AllowGifEmoji>
          <div className="msgflupldouter boxs">
            <ul className="msgfileuplad">
              <AllowGifEmoji>
                <li>
                  <img
                    onClick={e => openGifs(e)}
                    src="/img/gif.svg"
                    alt="file"
                    className="img-responsive msgemojiimg"
                  />
                </li>
              </AllowGifEmoji>
              <AllowGifEmoji>
                <li>
                  <img
                    onClick={e => openEmoji(e)}
                    src="/img/msgemoji.svg"
                    alt="file"
                    className="img-responsive msgemojiimg"
                  />
                </li>
              </AllowGifEmoji>
            </ul>
          </div>
        </AllowGifEmoji>
        <AllowGifEmoji>
          {showEmo &&
          <div className="emo-wrap" id="emo">
            <div className="emo-cov">
              <Picker
                onSelect={addEmoji}
                showPreview={false}
              />
              <i className="icon icon-tooltip-tail" />
            </div>
          </div>
        }
          {showGif &&
          <div className="gif-wrap" id="gif">
            <div className="gif-cov">
              <GifPicker onSelect={sendGif} />
              <i className="icon icon-tooltip-tail i-gif" />
            </div>
          </div>
        }
        </AllowGifEmoji>
        {attach &&
        <div className="boxs fontmulisemi Attchfilefdbck">
          <div className="leftfbw">
            <div className="boxs">
              { (mulTempFiles[upload_name] && mulTempFiles[upload_name].length) ?
                <span className="attchfilefbck ">{t('Attached files')}<span>({mulTempFiles[upload_name].length})</span>:</span> : ''}
            </div>
          </div>
          <div>
            <InputFile
              id={upload_name}
              groupFile
              label={<img src="/img/fileupload.svg" alt="file" className="img-responsive msgfileimg pointer" />}
              fields={prop => (
                <AttachedFile file={prop.file} onRemove={prop.onRemove} upload />
              )}
            />
          </div>
        </div>}
        {/*<ValidationMessage*/}
        {/*message={errorMessage}*/}
        {/*valid={!errorMessage}*/}
        {/*/>*/}
        {!checkKeyPress &&
        <div className="sendmsgbtnbox boxs sendmsgbtnboxslideup">
          {
            isEditing
              ? <button
                className="sendmsgbtn"
                onClick={e => cancelEdit(e)}
              >
                {t('Cancel')}
              </button>
              : ''
          }
          <button
            className="sendmsgbtn"
            onClick={e => preSubmit(e)}
            disabled={isSubmitting}
          >
            {t('Send message')}
          </button>
        </div>}
      </form>
    </div>
  </React.Fragment>
);

AddNew.propTypes = {
  label: PropTypes.string,
  onKeyPress: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  checkKeyPress: PropTypes.bool,
  attach: PropTypes.bool,
  isEditing: PropTypes.bool,
  errorMessage: PropTypes.string,
  showEmo: PropTypes.bool.isRequired,
  addEmoji: PropTypes.func.isRequired,
  preSubmit: PropTypes.func.isRequired,
  openEmoji: PropTypes.func.isRequired,
  newComment: PropTypes.string.isRequired,
  changeText: PropTypes.func.isRequired,
  upload_name: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  mulTempFiles: PropTypes.object,
};

export default AddNew;



// WEBPACK FOOTER //
// ./src/components/comments/addNew/AddNew.jsx